import React from 'react';

export const Card = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <div
    ref={ref}
    className={`rounded-lg border border-gray-200 bg-white shadow-sm ${className}`}
    {...props}
  >
    {children}
  </div>
));

Card.displayName = 'Card';

export const CardHeader = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <div ref={ref} className={`px-6 py-4 border-b border-gray-200 ${className}`} {...props}>
    {children}
  </div>
));

CardHeader.displayName = 'CardHeader';

export const CardTitle = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <h2 ref={ref} className={`text-xl font-bold text-gray-900 ${className}`} {...props}>
    {children}
  </h2>
));

CardTitle.displayName = 'CardTitle';

export const CardDescription = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <p ref={ref} className={`text-sm text-gray-600 ${className}`} {...props}>
    {children}
  </p>
));

CardDescription.displayName = 'CardDescription';

export const CardContent = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <div ref={ref} className={`px-6 py-4 ${className}`} {...props}>
    {children}
  </div>
));

CardContent.displayName = 'CardContent';

export const CardFooter = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <div ref={ref} className={`px-6 py-4 border-t border-gray-200 ${className}`} {...props}>
    {children}
  </div>
));

CardFooter.displayName = 'CardFooter';
